import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { mapState } from 'vuex';
import OptionalGroupItem from '../components/optional-group-item.vue';
import LanguagePacks from '../components/i18n/language-packs.vue';
import ColorConfig from '../components/color-config.vue';
import GameDifficulty from './game-difficulty.vue';
import MwConfigSwitch from './mw-config-switch';
import { isGlobalClickCategory, isAutoEndTime as _isAutoEndTime, isPlayAgain as _isPlayAgain, isYdClickCategory, isAutoClickCategory } from '@/views/creative/utils';

export default {
  components: {
    OptionalGroupItem: OptionalGroupItem,
    LanguagePacks: LanguagePacks,
    ColorConfig: ColorConfig,
    GameDifficulty: GameDifficulty,
    MwConfigSwitch: MwConfigSwitch
  },

  props: {
    category: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  computed: _extends({}, mapState({
    templateConfig: function templateConfig(state) {
      return state.creative.template.templateConfig;
    },
    gameDifficulty: function gameDifficulty(state) {
      return state.creative.template.gameDifficulty.toLowerCase();
    },
    mwConfig: function mwConfig(state) {
      return state.creative.template.templateConfig.mw_config;
    }
  }), {
    isAutoEndTime: function isAutoEndTime() {
      return _isAutoEndTime(this.category.id);
    },
    isPlayAgain: function isPlayAgain() {
      return _isPlayAgain(this.category.id);
    },
    isMwConfig: function isMwConfig() {
      var id = this.category.id;
      return isGlobalClickCategory(id) || isYdClickCategory(id) || isAutoClickCategory(id);
    },
    isI18n: function isI18n() {
      return this.category.prefix === 'i18n';
    },
    isColorConfig: function isColorConfig() {
      return this.category.prefix === 'colorConfig';
    },
    i18n: function i18n() {
      if (this.isI18n && this.category.resource_type && this.category.prefix) {
        return this.templateConfig.json_config.i18n;
      }
      return null;
    },
    colorConfig: function colorConfig() {
      if (this.isColorConfig) {
        var colorConfig = this.templateConfig.json_config.colorConfig;
        return _.cloneDeep(colorConfig);
      }
      return null;
    }
  }),

  methods: {
    /**
     * 根据属性路径信息更新配置
     * @param {any} val
     */
    updateJsonConfig: function updateJsonConfig(val) {
      var cloneConf = _.cloneDeep(this.templateConfig.json_config);
      cloneConf[this.category.prefix] = val;
      this.$store.commit('creative/template/updateJsonConfig', cloneConf);
    },
    addValidator: function addValidator(validate) {
      this.$store.commit('creative/template/addValidator', validate);
    }
  }
};